import * as types from "./actionTypes";
import * as authApi from "../../api/authApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function requestLogin(auth) {
    return { type: types.LOGIN_REQUEST, auth }
}

export function receiveLogin(auth) {
    return { type: types.LOGIN_SUCCESS, auth}
}

export function loginError(auth) {
    return { type: types.LOGIN_FAILURE, auth}
}

export function requestLogout(auth) {
    return { type: types.LOGOUT_REQUEST, auth }
}

export function receiveLogout(auth) {
    return { type: types.LOGOUT_SUCCESS, auth }
}

export function confirmUserlogin(user) {
    return { type: types.LOAD_USER_SUCCESS, user }
}

export function receiveRegisterUser(result) {
    return { type: types.REGISTER_SUCCESS, result}
}

export function receiveActivateAcount(result) {
    return { type: types.ACTIVATION_SUCCESS, result }
}

export function giveCookieConsent() {
    return dispatch => {
        localStorage.setItem('allowCookies', true);
        dispatch({ type: types.COOKIES_ALLOW });
    }
}

export function loginUser(credentials) {

    return dispatch => {
        // We dispatch requestLogin to kickoff the call to the API

        var auth = {
            isFetching: true,
            isAuthenticated: false
        }

        //dispatch(beginApiCall()); 
        //dispatch(requestLogin(auth));

        return authApi.login(credentials)
            .then(user => {
                
                auth.isFetching = false;

                if (!user.loginSuccessful) {
                    auth.isAuthenticated = false;
                    auth.message = user.message;
                    dispatch(loginError(auth));
                    return auth;
                }
                localStorage.setItem('isAuthenticated', true);
                auth.isAuthenticated = true;
                auth.message = "";
                auth.userId = user.userId;
                localStorage.setItem('uId', user.userId);
                dispatch(receiveLogin(auth));

                var loggedInUser = {
                    id: user.userId,
                    firstName: user.firstName,
                    surname: user.surname,
                    userName: user.userName,
                    isAdmin: user.isAdmin, 
                    preferredMeasurementUnits: user.preferredMeasurementUnits,
                    avatarAvailable: user.avatarAvailable,
                    avatarVersion: user.avatarVersion,
                    bannerAvailable: user.bannerAvailable,
                    bannerVersion: user.bannerVersion,
                    riderNetwork: user.riderNetwork
                }
                dispatch(confirmUserlogin(loggedInUser));

                return auth;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function checkLogin() {
    return dispatch => {
        return authApi.checkUserLogin()
            .then(result => {
                if (result.isAuthenticated) {
                    var user = {
                        id: result.user.userId,
                        firstName: result.user.firstName,
                        surname: result.user.surname,
                        userName: result.user.userName,
                        isAdmin: result.user.isAdmin, 
                        preferredMeasurementUnits: result.user.preferredMeasurementUnits,
                        avatarAvailable: result.user.avatarAvailable,
                        avatarVersion: result.user.avatarVersion,
                        bannerAvailable: result.user.bannerAvailable,
                        bannerVersion: result.user.bannerVersion,
                        riderNetwork: result.user.riderNetwork
                    }
                    dispatch(confirmUserlogin(user));
                    return { isAuthenticated: true };
                }
                else {
                    localStorage.setItem('isAuthenticated', false);
                    dispatch(receiveLogout({ isFetching: false, isAuthenticated: false }));
                    return { isAuthenticated: false };
                }
                
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error; 
            });
    }
}

export function logoutUser() {
    return dispatch => {
        var auth = { isFetching: true, isAuthenticated: false }
        dispatch(requestLogout(auth));

        return authApi.logout()
            .then(user => {
                localStorage.setItem('isAuthenticated', false);
                auth.isFetching = false;
                auth.isAuthenticated = false;
                dispatch(receiveLogout(auth));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function recoverUsername(email) {
    return authApi.recoverUsername(email);
}

export function requestPasswordReset(email) {
    return authApi.requestPasswordReset(email);   
} 

export function changePassword(changeDetails) {

    return dispatch => {
        return authApi.changePassword(changeDetails)
            .then(() => {
                return;
            }) 
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function resetPassword(reset) {

    return dispatch => {
        
        var auth = {
            isFetching: true,
            isAuthenticated: false
        }

        return authApi.resetPassword(reset)
            .then(user => {
                localStorage.setItem('isAuthenticated', true);
                auth.isAuthenticated = true;
                auth.message = "";
                auth.userId = user.userId;
                // Dispatch the success action

                dispatch(receiveLogin(auth));

                var user = {
                    id: user.userId,
                    firstName: user.firstName,
                    surname: user.surname,
                    userName: user.userName,
                    preferredMeasurementUnits: user.preferredMeasurementUnits,
                }
                dispatch(confirmUserlogin(user));

                return auth;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
} 

export function registerUser(user) {

    return dispatch => {
        return authApi.registerUser(user)
            .then(result => {
                dispatch(receiveRegisterUser(result));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
     
}

export function activateAcount(activationCode) {
    return dispatch => {
        return authApi.activateAcount(activationCode)
            .then(result => {
                dispatch(receiveActivateAcount(result));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js